<section class="Donation__Header">
  <div class="container">
    <div class="row">
      <div class="Donation__Header--text col-12 col-md-8">
        <img class="img-fluid" src="assets/images/spiral_black.svg" alt="" width="60">
        <h1 i18n>Programa de Apoyo: <br><span class="italic">Uniendo Esfuerzos, Transformando Vidas</span></h1>
        <h3 i18n>Explora nuestro reporte, donde podrás ver las contribuciones de nuestros generosos
          clientes y conocer las historias de quiénes han sido beneficiados. Juntos, estamos creando una cadena de apoyo
          y bienestar que transforma vidas. Aquí, cada donación es un paso hacia un futuro mejor para alguien que lo
          necesita. ¡Únete a nosotros y sé parte de este cambio positivo!</h3>
      </div>
      <div class="Donation__Header--bannerImg col-12 col-md-4">
        <img class="img-fluid" src="assets/images/png/support-program.png" alt="Foro Bhavani" />
      </div>
    </div>
  </div>
</section>
<section class="Donation__MainReports">
  <div class="container">
    <div class="Donation__MainReports--first">
      <p class="counter">
        <span>+{{counters?.beneficiaries}}</span>
      </p>
      <hr />
      <p class="description" i18n>Personas que han sido beneficiadas a través de nuestro programa de Becas Bhavani</p>
    </div>
    <div class="Donation__MainReports--second">
      <p class="counter">
        <span>+{{counters?.benefactors}}</span>
      </p>
      <hr />
      <p class="description" i18n>Han sido las personas han decidido transformar vidas con su generosidad alrededor del
        mundo.</p>
    </div>
  </div>
</section>
<section class="Donation__Explain">
  <div class="container medium-container">
    <div class="row mb-4">
      <p i18n>En Bhavani, estamos comprometidos con un objetivo claro: <span class="strong">hacer que nuestros programas
          terapéuticos sean
          accesibles para todos.</span> Creemos firmemente que las limitaciones financieras no deberían obstaculizar tu
        proceso
        de curación. <span class="strong">Por ello, ofrecemos apoyo a quienes no pueden afrontar los costos habituales,
          respaldado por la
          bondad de nuestra comunidad.</span></p>
      <p i18n>Nuestro compromiso social nos impulsa a trabajar incansablemente para que nadie se quede sin la
        oportunidad de mejorar su bienestar. <span class="strong">Gracias a las donaciones generosas de personas de todo
          el mundo, podemos
          garantizar que más individuos reciban la ayuda que necesitan para transformar sus vidas.</span></p>
      <p i18n>En Bhavani, <span class="strong">cada contribución cuenta y cada vida importa.</span> Juntos, estamos
        creando una red de apoyo y
        esperanza, <span class="strong">asegurando que todos tengan la oportunidad de tomar su salud en sus
          manos.</span></p>
    </div>
    <div class="row mt-4">
      <blockquote>
        <p i18n>Hazlo posible para alguien más</p>
      </blockquote>
    </div>
  </div>
</section>
<section class="Donation__Reports" data-sticky-container>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="Donation__Reports--beneficiares">
          <h3 i18n>Últimos Beneficiados: <br /><span class="italic">Historias de Transformación</span></h3>
          <p class="description" i18n>Conoce los protocolos terapéuticos con los que se han beneficiado y los países
            desde donde han recibido apoyo. Destacamos el alcance global de nuestras iniciativas y el impacto positivo
            que estamos logrando en la vida de muchas personas gracias a la generosidad de nuestra comunidad.</p>
          <div class="Donation__Card" *ngFor="let beneficiary of last_beneficiaries">
            <div class="personal">
              <p>{{beneficiary.initials}}</p>
              <p *ngIf="beneficiary.gender_w_i18n === 'femenine'" i18n>- Mujer - {{beneficiary.age}} años</p>
              <p *ngIf="beneficiary.gender_w_i18n === 'masculine'" i18n>- Hombre - {{beneficiary.age}} años</p>
            </div>
            <div class="">
              <p class="badge">{{ locale === 'es' ? beneficiary?.last_dosage_phase_name :
                beneficiary?.last_dosage_phase_name_en}}</p>
            </div>
            <footer>
              <div class="location">
                <img src="assets/images/location-icon.svg" width="20" alt="">
                <p>{{beneficiary.country}}</p>
              </div>
              <div class="date">
                <img src="assets/images/clock-icon.svg" width="20" alt="">
                <p>{{ beneficiary.updated_at | date}}</p>
              </div>
            </footer>
          </div>
          <div class="last_benefactors">
            <h3 class="mt-4" i18n>Últimos Benefactores: <br /><span class="italic">Héroes de la Generosidad</span></h3>
            <p i18n>Conoce el impacto de la generosidad de nuestra comunidad. Son ellos quienes han contribuido a que
              nuestros programas terapéuticos sean accesibles para todos, sin importar su situación financiera. Celebra
              con nosotros a estos héroes de la generosidad y sé testigo del cambio positivo que juntos estamos creando
              alrededor del mundo.</p>
            <div class="Donation__Card" *ngFor="let benefactor of this.last_benefactors">
              <div class="personal">
                <p>{{benefactor.initials}}</p>
                <p *ngIf="benefactor.gender_w_i18n === 'femenine'" i18n>- Mujer - {{benefactor.age}} años</p>
                <p *ngIf="benefactor.gender_w_i18n === 'masculine'" i18n>- Hombre - {{benefactor.age}} años</p>
              </div>
              <div class="">
                <p class="badge">{{benefactor?.order?.donation / 100 | currency:'':'$ ':'2.2-2':'en'}} <span
                    class="text-uppercase">{{benefactor?.order?.currency}}</span></p>
              </div>
              <footer>
                <div class="location">
                  <img src="assets/images/location-icon.svg" width="20" alt="">
                  <p>{{benefactor.country}}</p>
                </div>
                <div class="date">
                  <img src="assets/images/clock-icon.svg" width="20" alt="">
                  <p>{{benefactor?.order?.updated_at | date}}</p>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <img class="img-fluid sticky" src="assets/images/png/support-program-beneficiaries.png" alt="Programa de Apoyo"
          loading="lazy" data-margin-top="100" data-sticky-class="is-sticky" />
      </div>
    </div>
  </div>
</section>